<template>
    <div class="wz_wrapper">
        <div class="wz_header" style="position: relative;"> 
            <img :src="logoImageUrl" alt="춘천도시재생" />
            <div class="select_wrap" v-if="!isPreview && webZineList && webZineList.length > 0" style="position: absolute; right: 0px;">
                <select v-model="webzineId" placeholder="웹진 선택" title="웹진 선택"
                    id="wz_volume"
                        @change="changeWebzine()">
                    <option v-for="webzine in webZineList"
                            :key="webzine.webzine_id"
                            :value="webzine.webzine_id"
                            :label="webzine.webzine_title"></option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
    name: "WebZineViewHeader",
    computed: {
        ...mapGetters('webzineView', [
            'isPreview',
            'webZineList',
            'selectedWebZineId',
            'mode'
        ])
    },
    watch: {
        selectedWebZineId() {
            if (this.selectedWebZineId) {
                this.webzineId = this.selectedWebZineId;
            }
        }
    },
    mounted() {
        this.webzineId = this.selectedWebZineId;
    },
    data() {
        return {
            logoImageUrl: this.$baseURL + '/images/webzine/logo-webzine-text.svg',
            webzineId: undefined
        }
    },
    methods: {
        ...mapMutations('webzineView', [
            'setSelectedWebZineId'
        ]),
        changeWebzine() {
            if(this.webzineId !== 'all'){
                this.setSelectedWebZineId(this.webzineId);
            }
            const url = `/${this.mode}/${this.webzineId}`;
            this.$router.push(url);
        },
        copyToClipBoard() {
            const url = window.document.location.href;
            const textarea = document.createElement("textarea");
            document.body.appendChild(textarea);

            textarea.value = url;
            textarea.select();

            document.execCommand("copy");
            document.body.removeChild(textarea);
            this.$successMessage('클립보드에 복사되었습니다');
        },

        sendMail() {
            window.location.href = "mailto: "
        },

        moveHome() {
            window.location.href = this.$homeURL;
        }
    }
}
</script>

<style scoped>
.webzine-header__con /deep/ .el-input__inner {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-radius: 0 !important;
}

ol {
    list-style: none;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 40px;
}

.sns > li {
    padding: 0 2px;
}

.sns > li a {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
    text-align: center;
    font-size: 20px;
    text-decoration: none;
    transition: all 0.3s ease-out;
}

.sns > li a span {
    position: absolute;
    top: -1000px;
    left: -10000px;
    overflow: hidden;
    font-size: 1px;
    text-indent: -9999px;
    line-height: 0;
}

.sns li a.link:after {
    content: '\e9c0';
    color: #197bc2;
}

.sns li a.mail:after {
    content: '\ea07';
    color: #dd4c3a;
}

.sns li {
    display: inline-block
}

.sns li a {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
    text-align: center;
    font-size: 20px;
    text-decoration: none;
    transition: all 0.3s ease-out;
}

.sns li a:after {
    display: block;
    font-family: 'xeicon';
}

.sns li a.link:after {
    content: '\e9c0';
    color: #197bc2;
}

.sns li a.mail:after {
    content: '\ea07';
    color: #dd4c3a;
}

.sns li a:hover, .sns li a:focus {
    background-color: #555;
    border: 1px solid #444
}

.sns li a:hover:after, .sns li a:focus:after {
    color: #fff;
}
</style>
